import React, { ReactNode } from 'react';
import { Formik, Form, FieldAttributes } from 'formik';
import { Box } from '@tonic-ui/react';

type FormContainerProps = {
  id: string;
  initialValues: Record<string, unknown>;
  enableReinitialize: boolean;
  validateOnBlur?: boolean;
  validateOnChange?: boolean;
  validateOnMount?: boolean;
  submitAction: (formPayload: Record<string, unknown>) => Promise<unknown> | void;
  customValidation: Record<string, any>;
  children: ReactNode;
} & FieldAttributes<Record<string, unknown>>;

const FormContainer = ({
  id,
  initialValues = {},
  customValidation,
  enableReinitialize,
  validateOnBlur = false,
  validateOnChange = false,
  validateOnMount = false,
  submitAction,
  children,
  ...rest
}: FormContainerProps): JSX.Element => {
  return (
    <Box className={`c1c_${id}_wrapper`} {...rest}>
      <Formik
        initialValues={initialValues}
        enableReinitialize={enableReinitialize}
        validationSchema={customValidation}
        validateOnChange={validateOnChange}
        validateOnBlur={validateOnBlur}
        validateOnMount={validateOnMount}
        onSubmit={(data, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          submitAction({ ...data, setSubmitting, resetForm });
        }}
      >
        {({ handleSubmit }) => (
          <Form id={`c1c_form_${id}`} data-id={id} data-ux-id={id} onSubmit={handleSubmit}>
            {children}
          </Form>
        )}
      </Formik>
    </Box>
  );
};

FormContainer.displayName = 'FormContainer';

export default FormContainer;
